// Fetches and caches the "No School Days" Notion database (collection
// ef2c7fef-f305-46b8-aabd-d5910955b819) — one shared source for both
// schoolSchedule.js (Adam/Tantasqua) and kimberlySchedule.js
// (Kimberly/OSA), so there's one fetch and one place that knows the row
// shape, not two copies drifting apart.
//
// Rows: { date, school: "OSA" | "Tantasqua" | "Both", dayType: "No School" | "Half Day" | "Snow Day" }
// A "Snow Day" row counts as a full closure for isNoSchoolDay(); if a
// snow day is actually a delay (not a full closure), the affected
// person's file still needs a direct MANUAL_OVERRIDES-style entry — this
// table has no way to express delay length.

let rows = [];
let loadPromise = null;

/**
 * Fetches the table once (via the notion Netlify function) and caches the
 * rows in memory. Safe to call from multiple components — later calls
 * reuse the same in-flight/resolved promise. isNoSchoolDay()/isHalfDayDate()
 * read whatever's currently loaded (empty array before this resolves, or
 * if it fails), so callers can check them synchronously any time; calling
 * this first just makes sure they're not still empty.
 */
function loadNoSchoolDays() {
  if (loadPromise) return loadPromise;
  loadPromise = fetch("/.netlify/functions/notion?type=noSchoolDays")
    .then(r => r.json())
    .then(d => { rows = d.items || []; })
    .catch(() => {}); // best-effort — each person's hardcoded fallback dates still work if this fails
  return loadPromise;
}

function isNoSchoolDay(dateStr, school) {
  return rows.some(r => r.date === dateStr && (r.school === school || r.school === "Both") && (r.dayType === "No School" || r.dayType === "Snow Day"));
}

function isHalfDayDate(dateStr, school) {
  return rows.some(r => r.date === dateStr && (r.school === school || r.school === "Both") && r.dayType === "Half Day");
}

export { loadNoSchoolDays, isNoSchoolDay, isHalfDayDate };
